import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import Chart from "react-apexcharts";
import { Singleton } from "helper/tools";

import { useAuthStore } from "../../../../store/store";

export default function ClientesKPI() {
  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [chartType] = useState("pie");

  const [titleGraph, setTitleGraph] = useState("Ventas por Genero");

  /** FILTERS */
  const [kpiData, setKpiData] = useState([]);
  const [kpiLabels, setKpiLabels] = useState([]);

  const [options, setOptions] = useState(buildGraph());

  /** PAGING */
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  function buildGraph() {
    return {
      chart: {
        width: 380,
        type: "pie",
        height: "300px",
      },
      labels: kpiLabels,
      dataLabels: {
        enabled: true,
        formatter(val, opts) {
          const name = opts.w.globals.labels[opts.seriesIndex];
          return [name, val.toFixed(1) + "%"];
        },
      },
      tooltip: {
        y: {
          formatter: function (
            value,
            { series, seriesIndex, dataPointIndex, w },
          ) {
            if (value == null) return "?";
            return Singleton.getInstance().format(value);
          },
        },
      },
      legend: {
        show: true,
      },
      title: {
        text: titleGraph,
        align: "center",
      },
      dropShadow: {
        enabled: true,
        color: "#455d1a",
        top: 23,
        left: 44,
        formatter: function (val) {
          return val + "-->";
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: false,
            },
          },
        },
      ],
    };
  }

  useEffect(() => {
    console.log("--->");

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },
      },
      function (start, end, label) {
        //  var years = 23; //moment().diff(start, 'years');
        //  alert("You are " + years + " years old!");
      },
    );

    /*

    $(function() {

        var start = moment().subtract(29, 'days');
        var end = moment();

        function cb(start, end) {
            $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        }

        $('#reportrange').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    });
    
    */
    /*
    .daterangepicker({
      timePicker: true,
      startDate: 22, //moment().startOf("hour"),
      endDate: 33, //moment().startOf("hour").add(32, "hour"),
      locale: {
        format: "M/DD hh:mm A",
      },
    });*/

    let aMode = useAuthStore.getState().clienteDashboadDate;
    fetchData(aMode);

    console.log("--> aMode: " + aMode);

    const clienteDashboadDateHandle = useAuthStore.subscribe(
      (state) => state.productoDashboadDate,
      (value, prevValue) => {
        //  if (value && prevValue === false) {
        // TODO fix  setFireLogout(true);
        /*  setTimeout(() => {
          userLogout();
        }, 100);

        
        useAuthStore.setState({ inLogoutMode: false });*/
        fetchData(value);
        //}
      },
    );

    if (aMode == null) {
      aMode = new Date();
    }
    console.log(aMode);

    console.log(clienteDashboadDateHandle);

    //fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);

    return () => {
      clienteDashboadDateHandle();
    };
  }, []);

  useEffect(() => {
    setOptions(buildGraph());
  }, [titleGraph]);

  const fetchData = async (date) => {
    let criteria = {};
    searchFetchData(criteria, date);
  };

  /**
   * Search handler
   */

  const searchFetchData = async (criteria, date) => {
    if (date == null) {
      console.log("-->date to fetch is null. Ignoring Fetch_ ClientesKPI");
      return;
    }
    setIsLoading(true);

    criteria.sortAsc = true;

    //const date = new Date();

    criteria.FechaCreacion = date;

    const response = await api.VentasPorGenero(criteria).catch((error) => {
      toast.error("Error al Pedir Ventas por Genero.");
      setIsLoading(false);
    });
    if (!response) return;

    const exclude = "total";

    //[{mo: "coco", total: 123}, {mo: "plas", total: 998}].flatMap(s => Object.keys(s).filter(m=> m !== "total"))
    let labels = [];
    const allKeys = response.data.flatMap((s) =>
      Object.keys(s).filter((m) => m !== exclude),
    );
    if (allKeys != null) {
      const keys = [...new Set(allKeys)];
      if (keys.length > 0) {
        const key = keys[0];
        labels = response.data.flatMap((k) => k[key] ?? "-");
      }
    }

    setKpiLabels(labels);

    const aKpiData = response.data.map((e) => e.total);

    setKpiData(aKpiData);

    const sum = aKpiData.reduce((acc, curr) => acc + curr, 0);
    const sumValue = Singleton.getInstance().format(sum);
    setTitleGraph(`Ventas por Genero ${sumValue}`);

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    //  setAsociados(response.data.subset);

    setIsLoading(false);
  };

  return (
    <>
      <div className="">
        <div className="bd-example-row1">
          <div className="row">
            <div
              className="col card1 recent-sales overflow-auto"
              style={{
                backgroundColor: "transparent",
                borderRadius: "0px",
                marginBottom: "30px",
              }}
            >
              <div className="p-3 border bg-primary text-light report-card-title">
                <span>
                  Generos
                  <small className="text-muted"></small>
                </span>
              </div>
            </div>
          </div>

          <div className="row">
            {!isLoading && (
              <Chart
                options={options}
                series={kpiData}
                type={chartType}
                width="100%" // Do not omit
                height={350} // Do not omit
              />
            )}
            {isLoading && (
              <div
                className="animate-pulse"
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "300px",
                    width: "300px",
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
